export default {
  TableHead: [
    [
      {
        displayName: 'document.table.no',
      },
      {
        displayName: 'document.table.provider',
      },
      {
        displayName: 'document.table.documentseamless',
      },
      {
        displayName: 'document.table.documenttransfer',
      },
      {
        displayName: 'document.table.assest',
      },
      {
        displayName: 'document.table.edit',
        isHidden: true,
      },
      {
        displayName: 'document.table.delete',
        isHidden: true,
      },
    ],
  ],
};
